import { render, staticRenderFns } from "./HeadlineManagementPopup.vue?vue&type=template&id=5fc36e68&scoped=true"
import script from "./HeadlineManagementPopup.vue?vue&type=script&lang=js"
export * from "./HeadlineManagementPopup.vue?vue&type=script&lang=js"
import style0 from "./HeadlineManagementPopup.vue?vue&type=style&index=0&id=5fc36e68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc36e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc36e68')) {
      api.createRecord('5fc36e68', component.options)
    } else {
      api.reload('5fc36e68', component.options)
    }
    module.hot.accept("./HeadlineManagementPopup.vue?vue&type=template&id=5fc36e68&scoped=true", function () {
      api.rerender('5fc36e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/HeadlineManagementPopup.vue"
export default component.exports